import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=370b54f5&scoped=true"
import script from "./Attestation.vue?vue&type=script&lang=js"
export * from "./Attestation.vue?vue&type=script&lang=js"
import style0 from "./Attestation.vue?vue&type=style&index=0&id=370b54f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b54f5",
  null
  
)

export default component.exports